export default {
  getHead: () => {
    return [{ name: "연도" }, { name: "반기" }, { name: "지역" }, { name: "급별" }, { name: "학교(기관)명" }, { name: "이름" }, { name: "직종" }, { name: "이수여부" }, { name: "작성자" }];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0:
        return func.getContent(value).연도; // 연도
      case 1:
        return func.getContent(value).반기; // 반기
      case 2:
        return func.getContent(value).지역; // 지역
      case 3:
        return func.getContent(value).급별; // 급별
      case 4:
        return func.getContent(value).기관Data && func.getContent(value).기관Data.field_name; // 학교(기관)명
      case 5:
        return func.getContent(value).성명; // 이름
      case 6:
        return func.getContent(value).직종; // 직종
      case 7:
        return func.getContent(value).이수여부; // 이수여부
      case 8:
        return func.getContent(value).stdInfo.writer_name; // 작성자
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    return { searchYear: nav.value.searchYear, halfYear: nav.value.halfYear, searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword };
  },
  getSearchKeyword: (nav) => {
    const returnData = [];

    if (nav.value.searchYear) returnData.push(`customKeyword_content$body.연도*%${nav.value.searchYear}%`);
    if (nav.value.halfYear) returnData.push(`customKeyword_content$body.반기*%${nav.value.halfYear}%`);

    switch (nav.value.searchType) {
    case "지역":
      returnData.push(`content$body.지역*%[:default_skw]%`);
      break;
    case "급별":
      returnData.push(`content$body.급별*%[:default_skw]%`);
      break;
    case "학교(기관)명":
      returnData.push(`content$body.기관Data.field_name*%[:default_skw]%`);
      break;
    case "이름":
      returnData.push(`content$body.성명*%[:default_skw]%`);
      break;
    case "직종":
      returnData.push(`content$body.직종*%[:default_skw]%`);
      break;
    case "이수여부":
      returnData.push(`content$body.이수여부*%[:default_skw]%`);
      break;
    case "작성자":
      returnData.push("content$body.stdInfo.writer_name*%[:default_skw]%");
      break;
    }

    return returnData;
  },
};
